import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

const StyledH3 = styled.h3`
  font-size: 8.53vw;
  font-weight: 700;
  line-height: 10.67vw;
  letter-spacing: -2px;
  margin: 0;
  ${media.greaterThan("small")`
    font-size: 33px;
    line-height: 40px;
    letter-spacing: 2px;
    text-align: center;
    padding-top: 16px;
  `}
`
const StyledCorrect = styled.span`
  letter-spacing: 3px;
  ${media.greaterThan("small")`
    letter-spacing: 2px;
    margin: 0 2px 0 5px;
  `}
`
const StyledDot = styled.span`
  letter-spacing: 1px;
  margin: 0 6px 0 -3px;
  ${media.greaterThan("small")`
    letter-spacing: 3px;
    margin: auto;
  `}
`
const StyledSpan = styled.span`
  color: #0145a2;
  font-size: 11.73vw;
  font-weight: 900;
  line-height: 10.67vw;
  margin: 0;
  ${media.greaterThan("small")`
    font-size: 70px;
    line-height: 40px;
    margin-left: 6px;
  `}
`
const StyledBr = styled.br`
  ${media.greaterThan("small")`
    display: none;
  `}
`

const AText = props => {
  const text = props.text
  const answer = props.answer
  return (
    <StyledH3>
      {text}
      <StyledBr />
      <StyledCorrect>正解は</StyledCorrect>
      <StyledDot>...</StyledDot>
      <StyledSpan>{answer}</StyledSpan>
    </StyledH3>
  )
}

export default AText
